/**
 * Speech Therapy Missed Visit Report — options + empty payload.
 * Common header (1–6) via StNotesCommonHeader; clinical sections 7–13
 * plus professional attestation per ST Missed Visit mockups.
 */

import { emptyStCommonHeader } from "./stNotesCommonHeaderUtils";
import { newGoalId } from "../ptNotes/ptGoals";

export const PRIMARY_REASON_OPTIONS = [
  "Patient Cancelled",
  "Patient Hospitalized",
  "Therapist Emergency",
  "Scheduling Conflict",
  "No Show / No Answer",
  "Other",
];

export const OUTREACH_METHOD_OPTIONS = [
  "Phone Call",
  "Text Message",
  "Voicemail",
  "Email",
  "In Person",
];

export const YES_NO_OPTIONS = ["Yes", "No"];

export const ATTESTATION_TEXT =
  "I certify that the above information is a true and accurate reflection of the outreach performed and the clinical impact on the patient's Speech Therapy Plan of Care. I have followed all agency notification protocols regarding missed visits.";

export const today = () => new Date().toISOString().slice(0, 10);

export const emptyOutreachAttempt = (n = 1) => ({
  id: newGoalId(`oa-${n}`),
  date: "",
  time: "",
  method: "",
  outcome: "",
});

export const normalizeOutreachAttempts = (rows) => {
  const list = Array.isArray(rows) ? rows : [];
  if (!list.length) return [emptyOutreachAttempt(1)];
  return list.map((row, idx) => ({
    id: row?.id || newGoalId(`oa-${idx + 1}`),
    date: String(row?.date || "").trim(),
    time: String(row?.time || "").trim(),
    method: String(row?.method || "").trim(),
    outcome: String(row?.outcome || "").trim(),
  }));
};

export const emptyStMissedVisitPayload = () => ({
  billingCode: "G0153",
  timeIn: "",
  timeOut: "",
  missedVisitDate: today(),
  commonHeader: emptyStCommonHeader(),

  // —— 7. Primary Reason ——
  primaryReason: "",
  reasonOtherSpecify: "",
  detailedNarrative: "",

  // —— 8. Outreach & Communication Logs ——
  outreachAttempts: [emptyOutreachAttempt(1)],

  // —— 9. Plan of Care Analysis ——
  interventionsAffected: "",
  functionalImpact: "",

  // —— 10. Safety & Continuity ——
  patientSafeAtHome: "",
  exceedsFrequencyTolerance: "",

  // —— 11. Required Notifications ——
  physicianNotified: false,
  physicianNotifiedDate: "",
  physicianNotifiedTime: "",
  familyNotified: false,
  familyNotifiedDate: "",
  familyNotifiedTime: "",
  caseManagerNotified: false,
  caseManagerNotifiedDate: "",
  caseManagerNotifiedTime: "",

  // —— 12. Rescheduling ——
  rescheduledDate: "",
  frequencyAdjustment: "",

  // —— 13. Additional Comments ——
  additionalNotes: "",
});
